module.exports = __webpack_public_path__ + "images/line-chart-icon.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/line-chart-icon.png
// module id = 201
// module chunks = 0